import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import { FxLabel } from "./FxLabel";

export const FxTextField = (props) => {
  const { attr, onChangeValue, fxInObj } = props;
  const defaultValue = fxInObj[attr.attrName];
  const disabled = attr.readOnlyYn === "Y";
  const sx = {};
  const inputType = props.inputType === undefined ? "" : props.inputType;

  if (attr.uiWidth > 0) {
    sx.minWidth = attr.uiWidth;
    sx.width = attr.uiWidth;
  } else {
    sx.width = "100%";
  }
  function onChange(event) {
    onChangeValue(event.target.id, event.target.value);
  }

  console.log(
    "*** FxTextField ***",
    inputType,
    attr.attrName,
    fxInObj[attr.attrName]
  );

  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <input
        className={"FxTextField" + inputType}
        type="text"
        id={attr.attrName}
        style={sx}
        defaultValue={defaultValue}
        disabled={disabled}
        onChange={onChange}
      />
    </>
  );
};

export const FxTextField2 = (props) => {
  const { attrClass, para, defaultValue } = props;
  const sx = attrClass.getStyle();
  const inputType = para.inputType === undefined ? "" : para.inputType;

  function onChange(event) {
    if (para.onChange) para.onChange(event.target.id, event.target.value);
  }

  return (
    <>
      <input
        className={"FxTextField" + inputType}
        type="text"
        id={attrClass.getId()}
        style={sx}
        defaultValue={defaultValue}
        disabled={attrClass.isDisable()}
        onChange={onChange}
      />
    </>
  );
};

export const FxPassWordTextField = (props) => {
  const { attrClass, para, defaultValue, placeholder } = props;
  const sx = attrClass.getStyle();
  const inputType = para.inputType === undefined ? "" : para.inputType;

  function onChange(event) {
    if (para.onChange) para.onChange(event.target.id, event.target.value);
  }

  return (
    <>
      <input
        className={"FxTextField" + inputType}
        type="password"
        placeholder={placeholder}
        id={attrClass.getId()}
        style={sx}
        defaultValue={defaultValue}
        disabled={attrClass.isDisable()}
        onChange={onChange}
      />
    </>
  );
};

export const FxTextFieldMui = (props) => {
  const { attr, changeText, fxInObj, inputType } = props;
  const defaultValue = fxInObj[attr.attrName];

  const disabled = attr.readOnlyYn === "Y";
  const fullWidth = false;
  const sx = {};
  if (attr.uiWidth > 0) {
    sx.minWidth = attr.uiWidth;
    sx.width = attr.uiWidth;
  } else {
    fullWidth = true;
    sx.width = "100%";
  }

  return (
    <>
      <span className="FxLabelSearch">{attr.attrUiTxt}</span>
      <TextField
        className="FxTextFieldSearch"
        style={{ margin: "10px" }}
        size="small"
        hiddenLabel
        fullWidth={fullWidth}
        key={attr.attrName}
        id={attr.attrName}
        label={attr.attrUiTxt}
        onChange={changeText}
        defaultValue={defaultValue}
        variant="outlined"
        sx={sx}
        disabled={disabled}
      ></TextField>
    </>
  );
};

/**
 * 기본 Select 박스
 *
 * @param {function(id, value)} onChangeValue Select박스가 선택되었을 때 호출하는 함수 function(id, value)
 * @param {*} defaultValue 기본값
 * @param {string} name ID 및 이름
 * @param {string} className css명
 * @param {boolean} disabled 비활성화여부
 * @param {number} width 넓이
 * @param {object} selectedData 선택된 데이터
 * @returns
 */
export const FxTextFieldBase = (props) => {
  const {
    onChangeValue,
    name,
    className,
    disabled,
    width,
    defaultValue,
    selectedData,
  } = props;
  const sx = {};

  if (width) {
    sx.minWidth = width;
    sx.width = width;
  } else {
    sx.width = "99%";
  }

  function onChange(event) {
    onChangeValue(event.target.id, event.target.value);
  }

  return (
    <>
      <input
        className={className ? className : "FxTextField"}
        type="text"
        id={name}
        style={sx}
        value={
          defaultValue ? defaultValue : selectedData ? selectedData[name] : ""
        }
        disabled={disabled}
        onChange={onChange}
      />
    </>
  );
};
